import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class StationService {
  httpClient = inject(HttpClient);

  constructor() {}

  getStations(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/restaurants/stations').pipe(
      catchError((error) => {
        console.error('Error fetching stations:', error);
        return of(error);
      }),
    );
  }

  addStation(station: any): Observable<any> {
    return this.httpClient
      .post<any>(ServiceConstant.apiUrl + '/restaurants/stations', station)
      .pipe(
        catchError((error) => {
          console.error('Error creating station:', error);
          return of(error);
        }),
      );
  }

  editStation(station: any, stationId: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/restaurants/stations/' + stationId, station)
      .pipe(
        catchError((error) => {
          console.error('Error editing station:', error);
          return of(error);
        }),
      );
  }

  deleteStation(stationId: any): Observable<any> {
    return this.httpClient
      .delete<any>(ServiceConstant.apiUrl + '/restaurants/stations/' + stationId)
      .pipe(
        catchError((error) => {
          console.error('Error deleting stations:', error);
          return of(error);
        }),
      );
  }
}
